export const validateExpenseArrayObjects = (data) => {

    var isItem = false;
    var isAmount = false;

    data?.forEach((item) => {
        if(data.length === 0){
            isItem = true;
            isAmount = true;
        } else {
            if (item.items === "") {
                isItem = true;
            } else {
                isItem = false;
            }
    
            if (item.amounts === "") {
                isAmount = true;
            } else {
                isAmount = false;
            }

        }

    });
    return isItem || isAmount;
};

export const validatePaymentArrayObjects = (data) => {
    let isAmount = true;

    data?.forEach((item) => {
        if (!item || item.billing_details?.length === 0) {
            isAmount = true;
        } else {
            item.billing_details?.forEach((dataItem) => {
                if (dataItem.amount === undefined || dataItem.amount === "" || dataItem.amount === null) {
                    isAmount = true;
                } else {
                    isAmount = false;
                }
            });
        }
    });
    return isAmount;
};

